import React, { useState, useMemo } from "react";
import { Table, Button } from "react-bootstrap";

const TerminalAssessmentRankingTable = ({ data }) => {
  const [sortBy, setSortBy] = useState("ranking"); // Default sort by ranking
  const [sortOrder, setSortOrder] = useState("asc"); // asc or desc

  const sortedData = useMemo(() => {
    if (!data || data.length === 0) return [];

    return [...data].sort((a, b) => {
      let aValue, bValue;

      if (sortBy === "ranking") {
        aValue = a.ranking;
        bValue = b.ranking;
        if (aValue === bValue) {
          return a.name.localeCompare(b.name);
        }
      } else if (sortBy === "uid") {
        aValue = a.uid;
        bValue = b.uid;
      } else {
        aValue = a[sortBy];
        bValue = b[sortBy];
      }

      if (sortOrder === "asc") {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });
  }, [data, sortBy, sortOrder]);

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const getSortIcon = (column) => {
    if (sortBy !== column) return "↕️";
    return sortOrder === "asc" ? "↑" : "↓";
  };

  if (!data || data.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-muted">No ranking data available</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <style>
        {`
          @media print {
            .table-responsive {
              font-size: 10px !important;
            }
            .table th,
            .table td {
              font-size: 9px !important;
              padding: 2px 4px !important;
            }
            .table th {
              font-weight: bold !important;
            }
            .btn {
              font-size: 8px !important;
              padding: 1px 2px !important;
            }
          }
        `}
      </style>
      <Table striped bordered hover className="mb-0">
        <thead className="table-primary">
          <tr>
            <th>
              <Button
                variant="link"
                className="text-dark p-0 text-decoration-none"
                onClick={() => handleSort("ranking")}
              >
                Ranking {getSortIcon("ranking")}
              </Button>
            </th>
            <th>
              <Button
                variant="link"
                className="text-dark p-0 text-decoration-none"
                onClick={() => handleSort("uid")}
              >
                Roll {getSortIcon("uid")}
              </Button>
            </th>
            <th>Name</th>
            <th>Shift</th>
            <th>Batch</th>
            <th>Year</th>
            <th>Total Mark</th>
            <th>Full Mark</th>
            <th>Percentage</th>
            <th>Grade</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((student, index) => (
            <tr key={student.studentId}>
              <td className="text-center fw-bold">{student.ranking}</td>
              <td className="text-center">{student.uid}</td>
              <td className="fw-medium">{student.name}</td>
              <td className="text-center">{student.shift?.name || "-"}</td>
              <td className="text-center">{student.batch?.name || "-"}</td>
              <td className="text-center">{student.year}</td>
              <td className="text-center fw-bold">
                {parseFloat(student.totalMark).toFixed(2)}
              </td>
              <td className="text-center">{student.fullMark}</td>
              <td className="text-center">
                {parseFloat(student.percentage).toFixed(2)}%
              </td>
              <td className="text-center">{student.grade}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default TerminalAssessmentRankingTable;
